$(->
  $(document).on 'click', '.submit-update-form', ->
    formID = $(this).data('form-id')
    $(formID).submit()

  $('.file.input.has-error').each ->
    err_msg = $(this).find('span.help-block')
    err_msg.addClass('error')
    $(this).after(err_msg)

  $(document).on 'change', '.auto-submit', ->
    return if $(this).closest('form').hasClass('lazy-loaded')
    $(this).closest('form').submit()

  $(document).on 'click', '.input-group-addon .submit', ->
    $(this).closest('form').submit()
)
